import { Heading, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  isSpecialScore: boolean;
}

export function ScoreModalContent({ isSpecialScore }: Props) {
  return (
    <S.Main>
      <Heading as="h5" size={FontSize.font14} weight={FontWeight.bold}>
        Como avançar de nível?
      </Heading>

      <Text>
        O período analisado para o calculo do seu nível é de 15 dias corridos,
        seu desempenho neste tempo é o que determina seu nível e a prioridade
        para receber ou não pedidos dentro de uma mesma area que outras lojas.
      </Text>

      <Text>
        E quanto maior o percentual de aceite dos pedidos, maior será seu nível,
        pois entendemos que a sua loja conseguira atender mais, e assim, terá
        prioridade na disponibilização de novos pedidos no dashboard.
      </Text>

      {isSpecialScore && (
        <Text>
          A sua loja recebeu o nível 6 temporariamente para ter prioridade de
          atendimento, e assim calcularmos seu score real de atendimento.
        </Text>
      )}
    </S.Main>
  );
}
